<template>
  <svg
    class="pl-mark"
    viewBox="10 18 180 132"
    :width="width"
    :height="height"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <g stroke="currentColor" stroke-width="10" stroke-linejoin="round" stroke-linecap="round">
      <path d="M20 130 L60 42 L100 84 L145 28 L180 130 Q140 123 100 140 Q60 123 20 130 Z" />
      <path d="M100 84 V140" />
    </g>
  </svg>
</template>

<script setup>
import { computed } from 'vue'

// Znak Peakslog (public/peakslog-mark.svg) wstawiony inline, żeby kolor
// dziedziczył się przez currentColor. Skalowany proporcjonalnie 180:132;
// minimalna szerokość 20 px (mniejsze rozmiary: peakslog-favicon.svg).
const props = defineProps({
  width: { type: Number, default: 32 }
})

const height = computed(() => Math.round((props.width * 132) / 180 * 10) / 10)
</script>

<style scoped>
.pl-mark {
  display: block;
  flex-shrink: 0;
}
</style>
